export const TRIGGER_WORDS = ["cjw",
  "ohwx",
  "zxq",
  "vkp",
  "nyx",
  "jhk",
  "qmz",
  "wxv",
  "yfj",
  "kqx",
  "pzv",
  "mhx",
  "tjq",
  "rxk",
  "dwz",
  "lxj",
  "bhq",
  "fvx",
  "snq",
  "ymx",
  "gzk",
  "pqy",
  "kzn",
  "xjf",
  "qwm",
  "vzh",
  "yxp",
  "nqj",
  "wzk",
  "mvh",
  "tjx",
  "kpz",
  "fqw",
  "jvh",
  "wmx",
  "hzv",
  "pjq",
  "kxm",
  "yqz",
  "wvk",
  "txk",
  "kyx",
  "nzw",
  "vxh",
  "qmj",
  "fyk",
  "wxq",
  "lzv",
  "thx",
  "pnq",
  "kjw",
  "ymz",
  "vxq",
  "hfk",
  "wzj",
  "qxp",
  "nyv",
  "mhk",
  "txq",
  "bzw",
  "jvx",
  "kqy",
  "pzh",
  "wxm",
  "nfj",
  "yxq",
  "vzk",
  "htw",
  "qmx",
  "ljv",
  "pxk",
  "wnz",
  "yhq",
  "txf",
  "bzv",
  "kjm",
  "qxy",
  "nwh",
  "vzp",
  "fxq",
  "mjk",
  "wzy",
  "hxv",
  "qtp",
  "knx",
  "yjw",
  "vzm",
  "qxh",
  "bwk",
  "pzj"];